
  import { Component, Vue ,Prop, Watch ,Inject} from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import draggable from 'vuedraggable'
  import pageheader from "./pageheader.vue"
  import announcement from "./announcement.vue"
  import imgnavigation from "./imgnavigation.vue"
  import hotzone from "./hotzone.vue"
  import shopmode from "./shopmode.vue"
  import videomode from "./videomode.vue"
  import search from "./search.vue"
  import specialzone from "./specialzone.vue"
  import dailypackage from "./dailypackage.vue"
  import menulist from "./menulist.vue"
  import coupon from "./coupon.vue"
  import InstantDeath from "./InstantDeath.vue"
  import classifiedGoods from "./classifiedGoods.vue"
  @Component({  
    name: '',
    components: {
      draggable,
      PageFooter,
      pageheader,
      announcement,
      imgnavigation,
      hotzone,
      shopmode,
      videomode,
      search,
      specialzone,
      dailypackage,
      menulist,
      coupon,
      InstantDeath,
      classifiedGoods
    }
  })

  export default class ProductList extends Vue {
    private top = 0
    private doc = -1
    private modelist:any = []
    private movekey = ''
    @Inject() information:any
    get value(){
      // console.log(this.information,'mode')
      return this.information
    }
    @Inject() editinfo:any
    get editmsg(){
      return this.editinfo.msg
    }
    get moveindex(){
      // console.log(this.editinfo)
      if(this.editinfo.msg.value==3){
        return this.editinfo.moveindex
      }else{
        return -1
      }
    }

    get bgColor(){
      return this.value.find(v=>v.value==0)?.BackColor
    }
    @Watch('value',{deep:true})
    private synchronization(val){
      // console.log(val,123)
      this.modelist = val
    }
    
    private mounted () {
      //监听滚动
      window.addEventListener('scroll',this.gettop,true)
    }
    private destroyed () {
      //清除监听
      window.removeEventListener('scroll',this.gettop)
    }


    private endDraggable(list){
      this.movekey = ''
      this.doc = -1
      this.editinfo.msg = {}
      this.$emit('setData',this.modelist)
      // this.information = this.modelist.map(v=>v)
    }
    private upmove(){
      if(this.doc <= 1) return 
      let last = this.information[this.doc-1]
      this.information[this.doc-1] = this.information[this.doc]
      this.information[this.doc] = last
      this.doc-=1
      this.showedit()
      this.$forceUpdate()
      
    }
    private downmove(){
      //数组多了一个标题 应该不算进去
      if(this.doc>=this.value.length-1) return
      let next = this.information[this.doc+1]
      this.information[this.doc+1] = this.information[this.doc]
      this.information[this.doc] = next
      this.doc+=1
      this.showedit()
      this.$forceUpdate()
    }
    private deletemode(){
      this.information.splice(this.doc,1)
      this.editinfo.msg = {}
      this.doc = -1
      this.getunderModule()
    }
    private showedit(){
      this.editinfo.msg = this.value[this.doc]
      // console.log(this.value)
      if(this.editinfo.msg.value==9){
        this.getunderModule()
      }
      this.gettop()
    }
    //排序发生变化 定位菜单需要改动
    private getunderModule(){
      let index = this.value.map(v=>v.key).indexOf(this.editmsg.key)
      this.editinfo.msg.underModule =  this.information.filter((v,i)=>{
        return i > index
      }).map(v=>{
        return {
          key:v.key,
          moduleName:v.moduleName
        }
      })
      //移动到最后一个的时候
      if(index>=this.value.length){
        this.editinfo.msg.menuList = this.editinfo.msg.menuList.map(v=>{
          v.key = ''
          return v
        })
      }else{
        this.editinfo.msg.menuList = this.editinfo.msg.menuList.map(v=>{
          let current = this.editinfo.msg.underModule.find(x=>x.key==v.key)
          v.key = (current&&current.key)?current.key:''
          // console.log(current,v.key,'key')
          return v
        })
      }
    }
    private getwindowlocation(e,key){
      this.movekey = key
      this.doc = e
      this.gettop()
    }
    //让右侧的窗口跟当前的模块保持一致高度
    private gettop(){
      this.$nextTick(()=>{
        if(!(this as any).$refs['com'+this.doc]||!(this as any).$refs['com'+this.doc].length) return
        let top = 0
        if(this.doc == 0){
          top = 0
        }else{
          top = (this as any).$refs['com'+this.doc][0].getBoundingClientRect().top - (this as any).$refs.main.$el.getBoundingClientRect().top + 88
        }
        this.top = top
      })
    }  
  }
